<template>
  <div class="youlegoudetailpage">
    <div class="prodetaill_banner">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(img,index) in productDetail.images" :key="index">
          <img style="height: 100%;width: 100%;" v-lazy="img.image" />
        </van-swipe-item>
      </van-swipe>
      <!-- 	<mt-swipe v-if="banners" :auto="3000" :show-indicators="false">
				<mt-swipe-item>
					<div class="banner_imgbox" v-for="(img,index) in productDetail.images" :key="index">

						  <img class="prodetail_img" :src="img.image" />
					</div>
				</mt-swipe-item>
			</mt-swipe> -->
      <!-- <img :src="productDetail.banner" class="prodetail_img" /> -->
    </div>
    <div class="prodetail_desc">
      <div class="prodetail_price">
        <div class="prodetail_pricenow">
          <span class="pro_pricetip">￥</span>{{productDetail.price}}
        </div>
        <div class="prodetail_mprice">￥{{productDetail.m_price}}</div>
      </div>
      <div class="prodetail_text">
        <div class="prodetail_name">
          <!-- <div class="prodetil_hot">热卖</div> -->
          <!-- <span class="hot-none"> </span> -->
          {{productDetail.name}}
        </div>
      </div>
      <div class="prodetail_tip" v-if="productDetail.detail">{{productDetail.detail}}</div>
    </div>
    <div class="prodetail_parameter">
      <div class="pro_paramleft">邮费</div>
      <div class="pro_paramright2">商家包邮</div>
    </div>
    <div class="prodetail_parameter">
      <div class="pro_paramleft">规格</div>
      <div class="pro_paramright2" v-if="productDetail.items.length==0">默认</div>
      <div v-else class="pro_paramright1">
        <div class="pro_paramright" v-for="(item,index) in productDetail.items">{{item.name}}</div>
      </div>
    </div>
    <div class="prodetail_imgdetail">
      <div class="prodetail_imgtitle">
        <img class="prodetail_imgtitleimg" src="/static/tuwenxiangqing.png" />
      </div>
      <div class="detailimgbox1">
        <div ref="reportHTML" v-html="productDetail.content" class="web-con"></div>
      </div>

      <!-- <div v-for="(itemimage,indeximage) in productDetail.details">
        <img class="prodetail_detailimgs" :src="itemimage.image_url" />
      </div> -->
    </div>
    <div class="prodetail_bottom" @click="showpopup()">
      <div class="prodetail_buy">立即购买</div>
    </div>
    <!-- 弹出层  开始 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '75%' }">
      <div class="product_desc">
        <div class="desc_imgprice">
          <div class="product_img">
            <img class="product_imgdetail" :src="productDetail.thumb" />
          </div>
          <div class="product_price">
            <span class="pro_pricetip">￥</span>{{productDetail.price}}
          </div>
        </div>

        <!-- <div class="product_kucun">库存200件</div> -->
      </div>
      <div class="guige">规格</div>
      <div class="morenguige2" v-if="productDetail.items.length==0">默认规格</div>
      <div v-else class="specsbox">
        <div  v-for="(item,index) in productDetail.items" :class="item.check ? 'morenguige' : 'morenguige1'" @click="changeSpecs(index)">{{item.name}}</div>
      </div>
      <div class="product_buynum">
        <div class="shuliang">数量</div>
        <div class="numjiajian">
          <div class="jian" @click="numsjian">-</div>
          <div class="num">{{nums}}</div>
          <div class="jia" @click="numsjia">+</div>
        </div>
      </div>
      <div class="product_buy">
        <div class="product_quxiao" @click="closepopup()">取消</div>
        <div class="product_queding" @click="toProductBuy()">确定</div>
      </div>
    </van-popup>
    <!-- 弹出层  结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        banners: [{
          image: '/static/banner.png'
        }, {
          image: "/static/banner1.png"
        }],
        show: false, //是否弹框
        nums: 1, //购买数量
        //productDetail:"",//商品详情
        productDetail: {},
        productId: "", //商品列表传过来的商品id
        totalPrice: "", //商品总价
        specItems:{},//卡券列表可用卡券的商品规格
        
      }
    },
    created() {
      if (this.$route.query.id) {
        this.productId = this.$route.query.id
      }
      if (this.$route.query.items) {
        this.specItems = this.$route.query.items
      }
      this.request("getProductDetail", {
        id: this.productId,
        // type:4
      })

    },
    mounted() {

    },
    methods: {
      showpopup() {
        this.show = true
      },
      closepopup() {
        this.show = false
      },
      //更换规格
      changeSpecs(e){
        let that = this
        let detail = that.productDetail
        let list = detail.items
        console.log("list",list)
        console.log("list",list)
        for(let index in list){
          if(e==index){
            list[index].check = true
            detail.price = list[index].price
            detail.thumb = list[index].thumb
          }else{
            list[index].check = false
          }
        }
        that.productDetail = detail
      },
      //商品个数加减事件
      numsjia() {
        let that = this
        let nums = that.nums
        that.nums = nums + 1
        let price = Number(that.productDetail.price)
        let totalPrice = (price * that.nums).toFixed(2)
        that.totalPrice = totalPrice
        // let zej = (price * nums1 * (1 - that.data.jinzhe)).toFixed(2)

      },
      numsjian() {
        let that = this
        let nums = that.nums
        if (!(nums === 0)) {
          that.nums = nums - 1
          let price = Number(that.productDetail.price)
          let totalPrice = (price * that.nums).toFixed(2)
          that.totalPrice = totalPrice
          // let zongj = (price * nums1).toFixed(2)
          // if (that.data.gold_card) {
          //   let zej = (price * nums1 * (1 - that.data.jinzhe)).toFixed(2)
          //   this.setData({
          //     zej: zej
          //   })
          // } else {
          //   let zej = 0
          //   this.setData({
          //     zej: zej
          //   })
          // }
        }
      },
      toProductBuy() {
        let that = this
        if (this.nums == 0) {
          that.$toast({
            message: "数量不能少于1"
          })
          return
        }
        let list = that.productDetail.items
        let specs = '默认'
        let item_id = 0
        if(list.length>0){
          for(let index in list){
            if(list[index].check){
              specs = list[index].name
              item_id = list[index].id
            }
          }
        }
        let buymesg = {}
        if (!that.totalPrice) {
          that.totalPrice = (Number(that.productDetail.price) * that.nums).toFixed(2)
        }
        buymesg.totalPrice = that.totalPrice
        buymesg.nums = that.nums
        buymesg.thumb = that.productDetail.thumb
        buymesg.name = that.productDetail.name
        buymesg.id = that.productId
        buymesg.specs = specs
        buymesg.item_id = item_id
        that.$router.push({
          //name:"projectBuy",
          name: "youlegouBuy",
          query: {
            buymesg: JSON.stringify(buymesg)
          }
        })
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取订单信息列表
          case 'getProductDetail':
            httper.get('/shop/get-detail', requestData, res => {
              console.log("res", res)
              if (res.code == 0) {
                if(res.data.items.length>0){
                  res.data.items.map(v => {
                    that.$set(v, 'check', false)
                    return v
                  })
                  
                  if(this.specItems.item_id){
                    for (const i in res.data.items) {
                      if (this.specItems.item_id==res.data.items[i].id) {
                        res.data.items[i].check = true
                        res.data.price = res.data.items[i].price
                        res.data.thumb = res.data.items[i].thumb
                      }
                    }
                    console.log("specItems",this.specItems);
                  }else{
                    res.data.items[0].check = true
                    res.data.price = res.data.items[0].price
                    res.data.thumb = res.data.items[0].thumb
                  }
                  
                }

                this.productDetail = res.data
                console.log("this.productDetail",this.productDetail)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
              // that.list = res.data

              //}
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .van-swipe {
    width: 100%;
    height: 100%;
  }

  /* ..van-swipe-item img{
  height: 370px !important;
} */
  /* 	body {
		background-color: #F5F5F5;
	} */
  .youlegoudetailpage {
    background-color: #F5F5F5;
  }

  .prodetaill_banner {
    width: 100%;
    /* height: 30%; */
    /* height: 200px; */
    height: 370px;
  }

  .prodetail_img {
    width: 100%;
    height: 100%;
  }

  .prodetail_desc {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;

  }

  .prodetail_price {
    display: flex;
    align-items: center;

  }

  .prodetail_pricenow {
    font-size: 23px;
    color: #FF7906;
    margin-right: 10px;
  }

  .pro_pricetip {
    font-size: 15px;
    color: #FF7906;
    /* margin-right: 5px; */
  }

  .prodetail_mprice {
    color: #BBBBBB;
    font-size: 10px;
    text-decoration: line-through;
  }

  .prodetail_text {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
  }

  .prodetail_name {
    font-size: 15px;
    /*    display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical; */
  }

  /* .hot-none{
		width: 25px;
		height: 3px;
	} */

  .prodetil_hot {
    width: 25px;
    height: 14px;
    border: 1px solid #FF7906;
    border-radius: 1px;
    color: #FF7906;
    font-size: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    position: sticky;
    left: 0;

  }

  .prodetail_tip {
    font-size: 12px;
    color: #BBBBBB;
  }

  .prodetail_parameter {
    width: 100%;
    padding: 10px 20px;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .pro_paramleft {
    font-size: 15px;
    margin-right: 20px;
  }
  .pro_paramright2 {
    font-size: 15px;
  }

  .pro_paramright1 {
    width: calc(100% - 50px);
    display: -webkit-box;
        -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .pro_paramright {
    font-size: 15px;
    margin-right: 15px;
    /*    display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical; */
  }

  .prodetail_imgdetail {
    width: 100%;
    margin-top: 20px;
  }

  .prodetail_imgtitle {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
  }

  .prodetail_imgtitleimg {
    width: 45%;
    height: 15px;
  }

  .prodetail_detailimgs {
    width: 100%;
  }

  .prodetail_bottom {
    width: 100%;
    height: 70px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    bottom: 0;
    background-color: #fff;
  }

  .prodetail_buy {
    width: 90%;
    height: 38px;
    background-color: #FF7906;
    color: #fff;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 19px;
  }

  .product_desc {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 20px;
    margin-bottom: 20px;
  }

  .desc_imgprice {
    display: flex;
    align-items: flex-end;
  }

  .product_img {
    width: 100px;
    height: 100px;
    padding: 10px;
    box-sizing: border-box;
    /* margin-top: -30px; */
    margin-right: 20px;
  }

  .product_imgdetail {
    width: 100%;
    height: 100%;
  }

  .product_price {
    font-size: 19px;
    color: #FF7906;
  }

  .product_kucun {
    font-size: 12px;
    color: #BBBBBB;
  }

  .guige {
    font-size: 15px;
    margin-left: 20px;
  }

  .shuliang {
    font-size: 15px;
  }
.specsbox{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
  .morenguige {
  /*  width: 84px; */
    height: 23px;
    background: #FF7906;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    /* margin-left: 10px; */
    margin: 10px;
    padding: 5px;
    box-sizing: border-box;
  }

  .morenguige1 {
  /*  width: 84px; */
    height: 23px;
    background: #EEEEEE;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
   /* margin-left: 10px; */
    margin: 10px;
    padding: 5px;
    box-sizing: border-box;
  }
  .morenguige2{
     width: 84px;
      height: 23px;
      background: #FF7906;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
     /* margin-left: 10px; */
      margin: 10px;
  }

  .product_buynum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 20px 30px 20px;
  }

  .numjiajian {
    display: flex;
    align-items: center;
  }

  .jian {
    width: 23px;
    height: 23px;
    font-size: 12px;
    color: #A0A0A0;
    background-color: #EEEEEE;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .num {
    width: 69px;
    height: 23px;
    font-size: 12px;
    color: #A0A0A0;
    background-color: #EEEEEE;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
  }

  .jia {
    width: 23px;
    height: 23px;
    font-size: 12px;
    color: #A0A0A0;
    background-color: #EEEEEE;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product_buy {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .product_quxiao {
    width: 40%;
    height: 32px;
    background-color: #FFC500;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    border-radius: 19px;
  }

  .product_queding {
    width: 40%;
    height: 32px;
    background-color: #FF7906;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    border-radius: 19px;
  }

  .detailimgbox1 {
    max-width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
  }

  .detailimgbox1 img {
    width: 100%;
    height: 100%;
  }

  .detailimgbox1 div {
    width: 100%;
    height: 100%;
  }

  .web-con p {
    width: 100% !important;
    height: 100% !important;
    margin: unset;
    display: flex;
  }

  /* p+img{
    width: 100% !important;
    height: 100% !important;
  } */
  /* .detailimgbox1>div>p {
    width: 100% !important;
    height: 100% !important;
    margin: unset;
    display: flex;
  }
  .detailimgbox1>div>p>img {
    width: 100% !important;
    height: 100% !important;
  } */
</style>



// WEBPACK FOOTER //
// src/pages/youlegou/youlegoudetail.vue